import Cookies from "js-cookie";

export const NETWORK_COOKIE_ID = "chain-id";
export const availableNetworks =
	process.env.NEXT_PUBLIC_AVAILABLE_CHAINS?.split(",") || ["43114"];
export const setNetworkCookie = (networkId?: number | string) => {
	//have to check it because if we switch to ETHEREUM (on Metamask), it's getting 1 as networkId and as a result, our EagerConnect is getting user to switch to ETH
	if (availableNetworks.includes(networkId.toString())) {
		Cookies.set(
			NETWORK_COOKIE_ID,
			`${networkId ?? process.env.NEXT_PUBLIC_CHAIN_ID}`,
		);
	}
};
export const CHAIN_ID = () =>
	Cookies.get(NETWORK_COOKIE_ID) || process.env.NEXT_PUBLIC_CHAIN_ID;
